// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const TicketStarIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20",
  "aria-hidden": "true",
  "data-icon": "TicketStar/solid"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M13.875 3.217H8.258v2.516a.585.585 0 0 1-.583.584.585.585 0 0 1-.583-.584V3.217h-.967c-3.292 0-4.375.983-4.45 4.058a.565.565 0 0 0 .167.417c.108.116.25.175.416.175 1.167 0 2.125.966 2.125 2.133a2.141 2.141 0 0 1-2.125 2.133.56.56 0 0 0-.416.175.566.566 0 0 0-.167.417c.075 3.075 1.158 4.058 4.45 4.058h.967v-2.516c0-.325.266-.584.583-.584.317 0 .583.259.583.584v2.516h5.617c3.417 0 4.458-1.041 4.458-4.458v-4.65c0-3.417-1.041-4.458-4.458-4.458Zm1.517 6.7-.775.75c-.034.025-.042.075-.034.116l.184 1.059a.511.511 0 0 1-.209.508.51.51 0 0 1-.541.042l-.959-.5a.142.142 0 0 0-.116 0l-.959.5a.494.494 0 0 1-.241.058.52.52 0 0 1-.508-.608l.183-1.059a.15.15 0 0 0-.034-.116l-.775-.75a.513.513 0 0 1-.133-.525.492.492 0 0 1 .417-.35l1.066-.159a.166.166 0 0 0 .1-.066l.475-.967a.521.521 0 0 1 .925 0l.475.967c.017.041.05.066.092.066l1.067.159c.2.025.358.166.416.35a.479.479 0 0 1-.116.525Z"
}));
export default TicketStarIcon;